 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A00_COVER from '@/components/000_Cover'
 import A01_FM01 from '@/components/001_FM01'
 import A02_TITLEPAGE from '@/components/002_Titlepage'
 import A03_COPYRIGHT from '@/components/003_Copyright'
 import A04_CONTENTS from '@/components/004_Contents'
 import A05_ABBREVIATIONS from '@/components/005_Abbreviations'
 import A06_PREFACE from '@/components/006_Preface'
 import A07_INTRODUCTION from '@/components/007_Introduction'
 import A08_PART01 from '@/components/008_Part01'
 import A09_CHAPTER01 from '@/components/009_Chapter01'
 import A10_CHAPTER02 from '@/components/010_Chapter02'
 import A11_CHAPTER03 from '@/components/011_Chapter03'
 import A12_CHAPTER04 from '@/components/012_Chapter04'
 import A13_CHAPTER05 from '@/components/013_Chapter05'
 import A14_CHAPTER06 from '@/components/014_Chapter06'
 import A15_CHAPTER07 from '@/components/015_Chapter07'
 import A16_CHAPTER08 from '@/components/016_Chapter08'
 import A17_CHAPTER09 from '@/components/017_Chapter09'
 import A18_CHAPTER10 from '@/components/018_Chapter10'
 import A19_PART02 from '@/components/019_Part02'
 import A20_CHAPTER11 from '@/components/020_Chapter11'
 import A21_CHAPTER12 from '@/components/021_Chapter12'
 import A22_CHAPTER13 from '@/components/022_Chapter13'
 import A23_CHAPTER14 from '@/components/023_Chapter14'
 import A24_CHAPTER15 from '@/components/024_Chapter15'
 import A25_CHAPTER16 from '@/components/025_Chapter16'
 import A26_CHAPTER17 from '@/components/026_Chapter17'
 import A27_CHAPTER18 from '@/components/027_Chapter18'
 import A28_CHAPTER19 from '@/components/028_Chapter19'
 import A29_CHAPTER20 from '@/components/029_Chapter20'
 import A30_EPILOGUE from '@/components/030_Epilogue'
 import A31_BIBLIOGRAPHY from '@/components/031_Bibliography'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/004_Contents",
 			"name" : "004_Contents",
 			"component" : A04_CONTENTS
 		},
 		{
 			"path" : "/005_Abbreviations",
 			"name" : "005_Abbreviations",
 			"component" : A05_ABBREVIATIONS
 		},
 		{
 			"path" : "/006_Preface",
 			"name" : "006_Preface",
 			"component" : A06_PREFACE
 		},
 		{
 			"path" : "/007_Introduction",
 			"name" : "007_Introduction",
 			"component" : A07_INTRODUCTION
 		},
 		{
 			"path" : "/008_Part01",
 			"name" : "008_Part01",
 			"component" : A08_PART01
 		},
 		{
 			"path" : "/009_Chapter01",
 			"name" : "009_Chapter01",
 			"component" : A09_CHAPTER01
 		},
 		{
 			"path" : "/010_Chapter02",
 			"name" : "010_Chapter02",
 			"component" : A10_CHAPTER02
 		},
 		{
 			"path" : "/011_Chapter03",
 			"name" : "011_Chapter03",
 			"component" : A11_CHAPTER03
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js